import { createContext } from "react";

export const AssessementContext = createContext(null)